module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding5 section-padding4"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "rowFluid"
  }, [_c('div', {
    staticClass: "news_center_content"
  }, [_c('div', {
    staticClass: "span4 col-sm-12 wow fadeInDown",
    attrs: {
      "data-wow-delay": "1.2s"
    }
  }, [_c('div', {
    staticClass: "news_center_list",
    on: {
      "click": function($event) {
        return _vm.toNews()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "news_center_list_title"
  }, [_vm._v("新闻资讯")])])]), _vm._v(" "), _c('div', {
    staticClass: "span4 col-sm-12 wow fadeInUp",
    attrs: {
      "data-wow-delay": "0.7s"
    }
  }, [_c('div', {
    staticClass: "news_center_list",
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "news_center_list_title"
  }, [_vm._v("新品前言")])])]), _vm._v(" "), _c('div', {
    staticClass: "span4 col-sm-12 wow fadeInDown",
    attrs: {
      "data-wow-delay": "1.3s"
    }
  }, [_c('div', {
    staticClass: "news_center_list",
    on: {
      "click": function($event) {
        return _vm.toAbout()
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "news_center_list_title"
  }, [_vm._v("关于我们")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "carouselExampleIndicators",
      "data-ride": "carousel"
    }
  }, [_c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#carouselExampleIndicators",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carouselExampleIndicators",
      "data-slide-to": "1"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carouselExampleIndicators",
      "data-slide-to": "2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner"
  }, [_c('div', {
    staticClass: "carousel-item active"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": require("../assets/Banner01.jpg"),
      "alt": "..."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-item"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": require("../assets/Banner02.jpg"),
      "alt": "..."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-item"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": require("../assets/Banner03.jpg"),
      "alt": "..."
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news_center_list_img"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/038.jpg",
      "alt": "公司新闻"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news_center_list_img"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/034.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news_center_list_img"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/037.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17090762"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 302
// module chunks = 2